import { render, staticRenderFns } from "./settings-toggle-row.vue?vue&type=template&id=5c17da00&scoped=true&"
import script from "./settings-toggle-row.vue?vue&type=script&lang=js&"
export * from "./settings-toggle-row.vue?vue&type=script&lang=js&"
import style0 from "./settings-toggle-row.vue?vue&type=style&index=0&id=5c17da00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c17da00",
  null
  
)

export default component.exports